import React from 'react';

import {
  PeoPayrollProviderOrderBy,
  PeoPayrollProviderWhere,
  usePeoPayrollProvidersListQuery,
} from 'src/api';
import { PaginationQueryVariables } from 'src/hooks/common';

export const usePeoPayrollProvidersList = (
  filter: PeoPayrollProviderWhere,
  sort: PeoPayrollProviderOrderBy,
  paginationVariables: PaginationQueryVariables,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = usePeoPayrollProvidersListQuery({
    variables: {
      filter,
      orderBy: sort,
      ...paginationVariables,
    },
    notifyOnNetworkStatusChange,
  });

  const peoPayrollProviderList = React.useMemo(() => {
    return data?.peoPayrollProviderList ?? [];
  }, [data?.peoPayrollProviderList]);

  const peoPayrollProvidersCount = React.useMemo(() => {
    return data?.peoPayrollProviderCount || 0;
  }, [data?.peoPayrollProviderCount]);

  return {
    peoPayrollProviderList,
    peoPayrollProvidersCount,
    refetch,
    loading,
  };
};
